import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UnitService } from '../../../core/services/unit-service';

@Component({
  selector: 'app-llb-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class LlbEditComponent extends SecondPageEditBase implements OnInit {

  listGender: { label: string; value: number }[] = [{label: "Nam", value: 1}, {label: "Nữ", value: 0}];
  listUnit: { label: string; value: string }[] = [];
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang hoạt động', value: 1 },
    { label: 'Dừng hoạt động', value: 0 },
  ];
  listEthnic: { label: string; value: string }[] = [
    { label: 'Kinh', value: '1' },
    { label: 'Khác', value: '2' },
  ];

  constructor(
    protected _userService: UserService,
    protected _injector: Injector,
    private _unitService: UnitService,
  ) {
    super(_userService, _injector);
    this.formGroup = new UntypedFormGroup({
      llbCode: new UntypedFormControl([Validators.required]),
      email: new UntypedFormControl('', [Validators.email]),
      displayName: new UntypedFormControl('', [Validators.required]),
      phoneNumber: new UntypedFormControl('', [Validators.required, Validators.pattern(/^0\d{8,11}$/)]),
      gender: new UntypedFormControl('', [Validators.required]),
      userName: new UntypedFormControl([Validators.required]),
      dateOfBirth: new UntypedFormControl('', [Validators.required]),
      ethnic: new UntypedFormControl(''),
      idNumber: new UntypedFormControl('', [Validators.pattern(/^\d{9,12}$/)]),
      nation: new UntypedFormControl(''),
      address: new UntypedFormControl(''),
      unitCode: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
  }

  getListUnit() {
    this._unitService.getTreeUnitByUnitCode(this.currentUser?.unitCode).then((rs) => {
      if (rs.success) {
        this.listUnit = rs?.data
          ?.map((r) => ({
            label: `- ${r.unitName} (${r.unitCode})`,
            value: r.unitCode,
          }));
      } else {
        this.listUnit = [];
      }
    });
  }

  onShowPopup(itemId: any) {
    if (this.listUnit.length == 0) {
      this.getListUnit();
    }
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (itemId > 0) {
      this._userService.getById(itemId).then(async rs => {
        this.itemDetail = rs.data;
        if (this.itemDetail.dateOfBirth) {
          this.itemDetail.dateOfBirth = new Date(this.itemDetail.dateOfBirth);
        }
      }, error => {
        this._notifierService.showWarning(this._translateService.instant('MESSAGE.NOT_FOUND_ERROR'));
      });
    }
  }

  async save() {
    this.submitting = true;

    if (this.itemDetail.passwordHash !== this.itemDetail.confirmPassword) {
      this.formGroup.controls['passwordHash'].setErrors({ 'nomatch': true });
      this.formGroup.setErrors({ 'invalid': true });
      this.showValidateMessage();
      return;
    }

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this.onBeforeSave();
    if (this.itemDetail['id']) {
      this.onUpdate();
    }
  }

  onUpdate() {
    this._baseService.put(this.itemDetail['id'].toString(), this.itemDetail)
      .then(response => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      }, error => {
        this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      });
  }
}
